import { Component } from 'preact';
import axiosjsonp from 'axios-jsonp-pro'
//import axios from 'axios'

export default class ProductModule extends Component {



	clickedAddToCart = () => {

		this.setState({added: 'loading'})

			//fire itemCarouselATCClicked tracker
			if (typeof window !== "undefined") {
					window.dataLayer = window.dataLayer || [];
					//don't have to set dataLayer parameters here, they will already exist
					window.dataLayer.push({
						"event" : "cc.itemCarouselATCClicked",
						itemIdAddedToCart: this.props.itemId
					})
			} else {
					//window.not available
					//console.log('window na')
			}

		let addToCartUrl = "https://affil.walmart.com/cart/addToCart?format=jsonp&affp1=VJoOqWDT-FzSAv_pwCYDbHn3ThZ_K6DdaZFKS2O6QFk&lsPublisherId=mZBF1JmBhNo&walmartonly=1?&items=" + this.props.itemId  + "|1&veh=aff&u1=PMATC"


		return axiosjsonp.jsonp(addToCartUrl, {
    params: {
      jsonp: "callback",
      dataType: "jsonp",
      }
    })
		.then( result=> {
				if (result.success === true){
					this.setState({added: true})
				} else {
					throw new Error(result.message)
				}
		}).catch( err=> {
			console.error(err)
			this.setState({added: 'error'})
		})

	}


	constructor() {
		super();
		// set initial time:
		this.state = { added: false };
	}


render(){

	/*
	<a onClick={this.clickedAddToCart} href={secondaryAddToCartURL} target="_blank" rel="noopener noreferrer" >
		<button className='button blue-button btn' >
			Add to Cart
		</button>
	</a>
	*/

		//have to use this when other add to cart option is not working
		//let secondaryAddToCartURL = "http://c.affil.walmart.com/t/api01?l=http%3A%2F%2Faffil.walmart.com%2Fcart%2FaddToCart%3Fitems%3D" + this.props.itemId  + "%7C1%26affp1%3DVJoOqWDT-FzSAv_pwCYDbHn3ThZ_K6DdaZFKS2O6QFk%26affilsrc%3Dapi%26veh%3Daff%26wmlspartner%3Dreadonlyapi"

		if (this.state.added === false){
			return (
					<button className='button blue-button btn' onClick={this.clickedAddToCart} >
						Add to Cart
					</button>
			);
		} if (this.state.added === 'loading'){
			return (
					<button data-contenttype="pm" data-btnlocation="title" data-itemid={this.props.itemId} className='button blue-button'>
						<div className="lds-ring"><div /> <div /> <div /> <div /></div>
					</button>
			);
		} else if (this.state.added === 'error'){
			return (
				<button data-contenttype="pm" data-btnlocation="title" data-itemid={this.props.itemId} className='button blue-button'>
					Out of stock
				</button>
			)
		}

		return (
			<a  target="_blank" href="https://www.walmart.com/cart"  rel='noreferrer noopener'  >
				<button className='button orange-button' >
					View Cart
				</button>
			</a>
		);
	}

}



// WEBPACK FOOTER //
// ./components/util/addToCartButton.js